import { format } from "date-fns-tz"

const timezoneName = (date, timeZone) => {
  if (!date) {
    return
  }

  const pattern = new RegExp(
    /\s(Standard|Summer|Universal|Daylight)?\sTime/,
    "i"
  )
  return format(Date.parse(date), "zzzz", { timeZone }).replace(pattern, "")
}

export { timezoneName }
